const RESOURCE_NAME = "entities/studentUnavailabilitys";

export default {};
